import { Injectable } from '@angular/core';
import { ExamAgencyHttpService } from '../../services/exam-agency-http.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class AddEditExamAgencyHttpService {
  private BASE_URL = environment.apiBaseUrl;
  constructor(
    private readonly examAgencyHttpService: ExamAgencyHttpService,
    private readonly httpClient: HttpClient
  ) {}

  getExamAgencyById<T>(loginUserId: string, examAgencyId: string) {
    return this.examAgencyHttpService.getExamAgencyById<T>(
      loginUserId,
      examAgencyId
    );
  }

  getDropdownListByCode<T>(code: string): Observable<T[]> {
    return this.httpClient
      .get<{ resultList: T[] }>(`${this.BASE_URL}api/GetCodes/${code}`)
      .pipe(map((response) => response.resultList));
  }

  getState<T>(country: string) {
    return this.httpClient.get<Array<T>>(
      `${this.BASE_URL}api/getstates?countryCode=${country}`
    );
  }

  updateExamAgency<T, E>(examAgency: T) {
    return this.httpClient.post<T>(
      `${this.BASE_URL}api/InsertOrUpdateExamAgency`,
      examAgency
    );
  }
  createExamAgency<T, E>(examAgency: T) {
    return this.httpClient.post<T>(
      `${this.BASE_URL}api/InsertOrUpdateExamAgency`,
      examAgency
    );
  }
}
